import React, { useState, Fragment, useEffect } from 'react';
// import styles from "./ConTrend.module.css";
import { Card, Col, Input, Row, Space, Spin, Table, Typography } from 'antd';
import { SearchOutlined } from '@ant-design/icons';
import { fetchJsData } from '../../../../api';
import { crawl } from '../../../../api/util';
import { fetchUserSearch, newApps, modApps, cardCss, tabPageCss } from './columns';
const { Text } = Typography;

const CatChange = (props) => {
    const [load, setLoad] = useState(true);
    const [data, setData] = useState([]);

    useEffect(() => {
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [props.loader]);

    return (
        <div>
            {/* Card */}
            <Row style={{ margin: '5px', padding: '1px' }}>
                {/* <Col className="gutter-row" span={1}></Col> */}
                <Col className="gutter-row" span={23}>
                    {!props.loader ? (
                        <FetchTabSearch
                            submit={props.submit}
                            rel={props.rel}
                            usrRel={props.usrRel}
                            loader={props.loader}
                            data={[]}
                            col={newApps}
                            usrSel="MODIFIED"
                        />
                    ) : (
                        <Card loading={props.loader} style={{ width: '100%', minHeight: '80vh' }}></Card>
                    )}
                </Col>
            </Row>
        </div>
    );
};

const FetchTabSearch = (props) => {
    const [searchVal, setSearchVal] = useState(null);
    const [filteredData, setFilteredData] = useState([]);
    const [origData, setOrigData] = useState([]);
    const [searchIndex, setSearchIndex] = useState([]);
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        console.log('usr -', props.usrRel, props.rel);
        setLoading(true);
        const fetchData = async () => {
            const { data: users } = await fetchUserSearch(props.rel, props.rel - 1, props.usrSel, props.data);
            console.log('users');
            console.log(users);
            let id = 0;
            users.map((elem) => {
                elem.id = id++;
            });
            setOrigData(users);
            setFilteredData(users);
            const searchInd = users.map((user) => {
                const allValues = crawl(user);
                return { allValues: allValues.toString() };
            });
            setSearchIndex(searchInd);

            if (users) setLoading(false);
        };
        fetchData();
    }, [props.submit]);

    useEffect(() => {
        if (searchVal) {
            const reqData = searchIndex.map((user, index) => {
                if (user.allValues.toLowerCase().indexOf(searchVal.toLowerCase()) >= 0) return origData[index];
                return null;
            });
            setFilteredData(
                reqData.filter((user) => {
                    if (user) return true;
                    return false;
                })
            );
        } else setFilteredData(origData);
    }, [searchVal, origData, searchIndex, props.submit]);

    return (
        <>
            <div>
                <Row gutter={16}>
                    <Col span={24}>
                        <Card
                            title={
                                loading ? (
                                    <div>
                                        <Spin size="small" />
                                    </div>
                                ) : (
                                    <Row>
                                        <Col spane={6}>
                                            <Space size="small">
                                                <Text>
                                                    {'Release - ' +
                                                        (props.usrRel
                                                            ? props.usrRel.split('snapshot_v')[1].split('_')[0]
                                                            : '')}
                                                </Text>

                                                <Text>
                                                    Top App Category Changes (Subset of 'All App Categories', accounts
                                                    for 90% of App traffic across Netskope customer base)
                                                </Text>
                                            </Space>
                                        </Col>
                                    </Row>
                                )
                            }
                            loading={props.loader}
                            size="small"
                            // style={{ maxHeight: "80vh", overflow: "scroll" }}
                            style={{ minHeight: '80vh' }}
                            // bodyStyle={{ padding: "0", borderStyle: "hidden" }}
                            bodyStyle={cardCss}
                            headStyle={{ backgroundColor: '#F0F8FF', border: 0 }}
                            extra={
                                <Row>
                                    <Col span={21}>
                                        <Input
                                            onChange={(e) => setSearchVal(e.target.value)}
                                            prefix={<SearchOutlined className="site-form-item-icon" />}
                                            placeholder="Crawl Search"
                                            allowClear
                                        />
                                    </Col>
                                    <Col span={1}></Col>
                                    <Col className="gutter-row" span={2}>
                                        {' '}
                                        <div></div>
                                    </Col>
                                </Row>
                            }
                        >
                            <Fragment>
                                <Table
                                    rowKey="id"
                                    size="small"
                                    bordered
                                    scroll={{ x: 550, y: 900 }}
                                    style={{ margin: '2px' }}
                                    dataSource={filteredData}
                                    columns={props.col(filteredData.length)}
                                    loading={loading}
                                    pagination={{
                                        pageSizeOptions: ['10', '30', '60', '100', '1000'],
                                        defaultPageSize: ['50'],
                                        showSizeChanger: true,
                                        // style: { padding: "0", marginBottom: "0" },
                                        style: tabPageCss,
                                    }}
                                />
                            </Fragment>
                        </Card>
                    </Col>
                </Row>
            </div>
        </>
    );
};

export default CatChange;
